import { ChainId } from "@pancakeswap/sdk";
import { Chain } from "viem"
import {
  fantomTestnet,
  fantom,
  arbitrum,
  optimism,
  optimismGoerli,
  polygonZkEvm,
  polygonZkEvmTestnet,
  base
} from 'viem/chains'
import { parseGwei } from 'viem'

type ChainType = {
  chainName: [string];
  chainId: string;
};
type JSONList<T> = T[];

export const CHAIN_ID = {
  FANTOM: JSON.parse(import.meta.env.VITE_FANTOM_CHAIN_ID),
  OPTIMISM: JSON.parse(import.meta.env.VITE_OPTIMISM_CHAIN_ID),
  POLYGON_ZKEVM: JSON.parse(import.meta.env.VITE_POLYGON_ZKEVM_CHAIN_ID),
  ARBITRUM_ONE: JSON.parse(import.meta.env.VITE_ARBITRUM_ONE_CHAIN_ID),
  BASE: JSON.parse(import.meta.env.VITE_BASE_CHAIN_ID),
  SHIMMER: JSON.parse(import.meta.env.VITE_SHIMMER_CHAIN_ID),
  IOTA: JSON.parse(import.meta.env.VITE_IOTA_CHAIN_ID),
  SONIC: JSON.parse(import.meta.env.VITE_SONIC_CHAIN_ID)
}

export const SUPPORTED_CHAINS: number[] = JSON.parse(import.meta.env.VITE_SUPPORTED_CHAINS)

// export const NETWORKS = [
//   {
//     chainId: CHAIN_ID.FANTOM,
//     label: NETWORK_LABEL[CHAIN_ID.FANTOM],
//   },
//   {
//     chainId: CHAIN_ID.OPTIMISM,
//     label: NETWORK_LABEL[CHAIN_ID.OPTIMISM],
//   },
//   {
//     chainId: CHAIN_ID.POLYGON_ZKEVM,
//     label: NETWORK_LABEL[CHAIN_ID.POLYGON_ZKEVM],
//   },
//   {
//     chainId: CHAIN_ID.ARBITRUM_ONE,
//     label: NETWORK_LABEL[CHAIN_ID.ARBITRUM_ONE],
//   },
//   {
//     chainId: CHAIN_ID.BASE,
//     label: NETWORK_LABEL[CHAIN_ID.BASE],
//   },
//   {
//     chainId: CHAIN_ID.SHIMMER,
//     label: NETWORK_LABEL[CHAIN_ID.SHIMMER],
//   },
// ]



export const shimmerTestnet = {
  id: 1073,
  name: 'ShimmerEVM Testnet',
  network: 'shimmerevm-testnet',
  nativeCurrency: {
    decimals: 18,
    name: 'Shimmer',
    symbol: 'SMR',
  },
  rpcUrls: {
    public: { http: ['https://json-rpc.evm.testnet.shimmer.network'] },
    default: { http: ['https://json-rpc.evm.testnet.shimmer.network'] },
  },
  blockExplorers: {
    etherscan: { name: 'Shimmer', url: 'https://explorer.evm.testnet.shimmer.network/' },
    default: { name: 'Shimmer', url: 'https://explorer.evm.testnet.shimmer.network/' },
  },
  contracts: {
    multicall3: {
      address: '0x87c2674179B3A5E70c095f1517BBA711a447754F',
      blockCreated: 2587,
    },
  },
  fees:  {
    async estimateFeesPerGas({ client, multiply, type }) {
      return { gasPrice: undefined}
    }
  }
} as const satisfies Chain


export const shimmerMainnet = {
  id: 148,
  name: 'ShimmerEVM',
  network: 'shimmerevm',
  nativeCurrency: {
    decimals: 18,
    name: 'Shimmer',
    symbol: 'SMR',
  },
  rpcUrls: {
    public: { http: ['https://json-rpc.evm.shimmer.network'] },
    default: { http: ['https://json-rpc.evm.shimmer.network'] },
  },
  blockExplorers: {
    etherscan: { name: 'Shimmer', url: 'https://explorer.evm.shimmer.network/' },
    default: { name: 'Shimmer', url: 'https://explorer.evm.shimmer.network/' },
  },
  contracts: {
    multicall3: {
      address: '0xcA11bde05977b3631167028862bE2a173976CA11',
      blockCreated: 1290,
    },
  },
  fees:  {
    async estimateFeesPerGas({ client, multiply, type }) {
      return { gasPrice: undefined}
    }
  }
} as const satisfies Chain

export const iotaTestnet = {
  id: 1075,
  name: 'Iota EVM Testnet',
  network: 'iotaevm',
  nativeCurrency: {
    decimals: 18,
    name: 'Iota',
    symbol: 'IOTA',
  },
  rpcUrls: {
    public: { http: ['https://json-rpc.evm.testnet.iotaledger.net/'] },
    default: { http: ['https://json-rpc.evm.testnet.iotaledger.net/'] },
  },
  blockExplorers: {
    etherscan: { name: 'Iota', url: 'https://explorer.evm.iota.org/' },
    default: { name: 'Iota', url: 'https://explorer.evm.iota.org/' },
  },
  contracts: {
    multicall3: {
      address: '0xa0229891BaC4777656f77Ca761E1fac8B9Cf8283',
      blockCreated: 1474,
    },
  },
  fees:  {
    async estimateFeesPerGas({ client, multiply, type }) {
      return { gasPrice: undefined}
    }
  }
} as const satisfies Chain

export const iotaMainnet = {
  id: 8822,
  name: 'Iota EVM',
  network: 'iotaevm',
  nativeCurrency: {
    decimals: 18,
    name: 'Iota',
    symbol: 'IOTA',
  },
  rpcUrls: {
    public: { http: ['https://json-rpc.evm.iotaledger.net/'] },
    default: { http: ['https://json-rpc.evm.iotaledger.net/'] },
  },
  blockExplorers: {
    etherscan: { name: 'Iota', url: 'https://explorer.evm.iota.org/' },
    default: { name: 'Iota', url: 'https://explorer.evm.iota.org/' },
  },
  contracts: {
    multicall3: {
      address: '0xAD30c5135468BcC647add3370B505b88219CF1Fe',
      blockCreated: 14073,
    },
  },
  fees:  {
    async estimateFeesPerGas({ client, multiply, type }) {
      return { gasPrice: undefined}
    }
  }
} as const satisfies Chain

export const sonicMainnet = {
  id: 146,
  name: 'Sonic EVM',
  network: 'sonicevm',
  nativeCurrency: {
    decimals: 18,
    name: 'Sonic',
    symbol: 'SONIC',
  },
  rpcUrls: {
    public: { http: ['https://rpc.soniclabs.com/'] },
    default: { http: ['https://rpc.soniclabs.com/'] },
  },
  blockExplorers: {
    etherscan: { name: 'Sonic', url: 'https://explorer.soniclabs.com/' },
    default: { name: 'Sonic', url: 'https://explorer.soniclabs.com/' },
  },
  contracts: {
    multicall3: {
      address: '0xAD30c5135468BcC647add3370B505b88219CF1Fe',
      blockCreated: 14073,
    },
  },
  fees:  {
    async estimateFeesPerGas({ client, multiply, type }) {
      return { gasPrice: undefined}
    }
  }
} as const satisfies Chain

export const satoshiVmTestnet = {
  id: 3110,
  name: 'SatoshiVM Testnet',
  network: 'satoshivm_testnet',
  nativeCurrency: {
    decimals: 18,
    name: 'Bitcoin',
    symbol: 'BTC',
  },
  rpcUrls: {
    public: { http: ['https://test-rpc-node-http.svmscan.io/'] },
    default: { http: ['https://test-rpc-node-http.svmscan.io/'] },
  },
  blockExplorers: {
    etherscan: { name: 'Svmscan', url: 'https://testnet.svmscan.io/' },
    default: { name: 'Svmscan', url: 'https://testnet.svmscan.io/' },
  },
  contracts: {
    multicall3: {
      address: '0x00D5fB018BC973f4D7b4B46E06CF834D6105ba0e',
      blockCreated: 187676,
    },
  },
  fees: {
    async estimateFeesPerGas({ client, multiply, type }) {
      return {
        maxFeePerGas: parseGwei("0.01"),
        maxPriorityFeePerGas: parseGwei('0.01')
      }
    }
    // async defaultPriorityFee({ block, request }) {
    //   console.log('default fee')
    //   // some async work
    //   return parseGwei('0.01')
    // },
  }
} as const satisfies Chain


export const PUBLIC_NODES = {
  [ChainId.SHIMMER_EVM] : [
    'https://json-rpc.evm.testnet.shimmer.network'
  ],
  [ChainId.SHIMMER_MAINNET] : [
    'https://json-rpc.evm.shimmer.network'
  ],
  [ChainId.FANTOM] : [
    'https://rpc.fantom.network'
  ],
  [ChainId.FANTOM_TESTNET] : [
    'https://rpc.testnet.fantom.network/'
  ],
  [ChainId.OPTIMISM]: [
    'https://opt-mainnet.g.alchemy.com/v2/C_-p6gNh0y35_3mbVObV9kSVLQIRZaSD'
  ],
  [ChainId.OPTIMISM_GOERLI] : [
    'https://goerli.optimism.io'
  ],
  [ChainId.ARBITRUM_ONE] : [
    'https://arb1.arbitrum.io/rpc'
  ],
  [ChainId.POLYGON_ZKEVM] : [
    'https://zkevm-rpc.com'
  ],
  [ChainId.POLYGON_ZKEVM_TESTNET] : [
    'https://rpc.public.zkevm-test.net'
  ],
  [ChainId.BASE] : [
    'https://base-mainnet.blastapi.io/a11f3451-e104-458f-846f-ecf17076c523'
  ],
  [iotaTestnet.id]: [
    'https://json-rpc.evm.testnet.iotaledger.net'
  ],
  [iotaMainnet.id]: [
    'https://json-rpc.evm.iotaledger.net'
  ],
  [sonicMainnet.id]: [
    'https://rpc.soniclabs.com'
  ]
}

export const VIEM_CHAINS = [
  iotaTestnet,
  iotaMainnet,
  shimmerTestnet,
  shimmerMainnet,
  fantomTestnet,
  fantom,
  sonicMainnet,
  arbitrum,
  optimism,
  optimismGoerli,
  polygonZkEvm,
  polygonZkEvmTestnet,
  base,
  satoshiVmTestnet
].filter((chain) => SUPPORTED_CHAINS.includes(chain.id))


export const BLOCK_EXPLORER_CHAIN_MAP = VIEM_CHAINS.reduce( (acc, val) => {
  acc[val.id] = val?.blockExplorers?.default?.url
  return acc
}, {})

export const AVAILABLE_NETWORKS = VIEM_CHAINS.map((chain) => {
  return {
    chainId: chain.id,
    label: chain.name
  }
})

export const NETWORK_NAMES = VIEM_CHAINS.reduce( (acc, val) => {
  acc[val.id] = val.network
  return acc
}, {})



export const isValidChainId = chainId => Object.values(SUPPORTED_CHAINS).includes(Number.parseInt(chainId))
